import createReactClass from 'create-react-class';
// Import Libraries
import React from 'react';
import PropTypes from 'prop-types';
// Import JS Modules
import AddPhotosDevice from '../common/add-photos-device';
import genericHelpers from '../../_utils/generic-helpers';
import startSessionTimeout from '../../_utils/tools/session-timeout';
import FinishSelector from './finish-selector';
import DeliverySelector from './delivery-selector';
import PhotosFilter from './photos-filter';
import PhotosGrid from './photos-grid';
import PhotoRemoveConfirmation from '../common/photo-remove-confirmation';
import PrintsBuilderMixin from '../common/prints-builder-mixin';
import SiteLogo from '../../_application/site-logo';
import SizeHelpers from '../common/size-helpers';
import Totaliser from '../common/totalizer';
import AddToCartControls from '../common/add-to-cart-controls';
import InvalidSizesModal from '../common/invalid-sizes-modal';
import InvalidDeliveryOptionModal from '../common/invalid-delivery-option-modal';
import UploadPhotosMixin from '../common/upload-photos-mixin';
import UploadProgressBar from '../common/upload-progress-bar';
import FullScreenSpinner from '../../_prism-builder/desktop/notices/full-screen-spinner';
import AdvancedEditor from '../common/advanced-editor';
import PrintFinishTabs from '../common/print_finish_tabs';
import { PrintsBuilderUrlsShape } from '../prop-types';
import { sortedAndFilteredImages } from '../common/images-helper';
import Button from '../../_common/button';
import { totalQuantity } from '../common/totalizing-mixin';
import Footer from './footer';
import { allPhotosCollectedByRootImage } from '../common/collect-by-root-image';
import BulkQuantityChange from '../common/bulk-quantity-change';

// -----------------------------------------------------------
//  Controller
// -----------------------------------------------------------
const MobilePrintsBuilder = createReactClass({
  mixins: [PrintsBuilderMixin, UploadPhotosMixin],
  displayName: 'Mobile prints builder',
  _photoIDs: {},
  getInitialState() {
    return {
      finish: {},
      delivery_option: {},
      sizes: [],
    };
  },
  UNSAFE_componentWillMount() {
    this.loadData();

    // loader callbacks
    this.loadCallbacks();

    this._forceUpdate = genericHelpers.debounce(() => this.forceUpdate());
  },
  componentDidMount() {
    this.handleViewportResize();
    window.addEventListener('resize', this.handleViewportResize);
    this.handleSessionTimeout();
  },
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleViewportResize);
    this.unloadCallbacks();
  },
  render() {
    const {
      delivery_option: deliveryOption,
      viewingSizeKey,
      currentlyLoading,
      finish,
      ready,
      invalidDeliveryOptionSelected,
    } = this.state;
    const {
      features: { allowMultiplePrintFinishesPerOrder },
      urls,
    } = this.props;
    const availableSizes = this.availableSizesForSelectedDeliveryAndFinish();
    const sizes = this.state.sizes
      .filter(SizeHelpers.sizeHasPrints)
      .map(SizeHelpers.stripZeroQuantityPhotosFromSize);
    const sizesByFinish = this.getSizesByFinish().filter(
      SizeHelpers.sizeHasPrints
    );

    // Keeps a record of the original order of prints
    const photos = allPhotosCollectedByRootImage(sizes);
    Object.entries(photos).forEach(([id, size]) => {
      this._photoIDs[id] = Object.entries(size).map(([, [photo]]) => photo.id);
    });

    const orderedPhotos = sortedAndFilteredImages({
      sizes,
      photoIds: this._photoIDs,
      viewingSizeKey,
      finish,
    });
    const orderedPhotosLength = totalQuantity(orderedPhotos);
    const deliveryOptions = [...this.data.delivery_options];
    const finishes = [...this.data.finishes];
    const finishesByDeliveryOption = Object.assign(
      {},
      this.availableFinishesByDeliveryOption
    );

    return (
      <div className="prints-builder__grid m-web">
        <header className="prints-builder__header d-flex align-items-center">
          <div className="flex-grow-1">
            <SiteLogo />
          </div>
          <Totaliser sizes={sizes} deliveryOption={deliveryOption} />
        </header>
        <aside className="print-order__summary-and-filter">
          {allowMultiplePrintFinishesPerOrder && (
            <PrintFinishTabs finishes={finishes} selectedFinish={finish} />
          )}
          <div className="grey-zone print-order__summary-container">
            <div className="d-flex align-items-center">
              <div className="flex-grow-1">
                <button
                  className="btn btn-link p-0 border-0 collapsed print-order__title"
                  type="button"
                  data-toggle="collapse"
                  data-target="#summary-chart"
                  aria-expanded="true"
                  aria-controls="summary-chart"
                  aria-label="Your Print Order">
                  <span>Print order</span>
                </button>
              </div>
              <div>
                <AddToCartControls
                  enabled={this.hasPrints() && !currentlyLoading}
                  basketUrl={urls.cart_page}
                  onAddToCart={this.handleAddToCart}
                />
              </div>
            </div>

            <div id="summary-chart" className="collapse show">
              <hr />
              <div className="print-order__summary">
                {!allowMultiplePrintFinishesPerOrder && (
                  <FinishSelector
                    deliveryOption={deliveryOption}
                    finishesByDeliveryOption={finishesByDeliveryOption}
                    finishes={finishes}
                    finish={finish}
                    onChange={this.handleOptionsChanged}
                  />
                )}
                <DeliverySelector
                  deliveryOptions={deliveryOptions}
                  deliveryOption={deliveryOption}
                  finishesByDeliveryOption={finishesByDeliveryOption}
                  finish={finish}
                  onChange={this.handleOptionsChanged}
                />
                <BulkQuantityChange
                  sizes={sizes}
                  photos={this.allPhotos()}
                  onChange={this.handleQuantityChanged}
                  disabled={!this.hasPrints() || !!this.state.currentlyLoading}
                  availableSizes={availableSizes}
                  deliveryOption={deliveryOption}
                />
              </div>
            </div>
          </div>
          <UploadProgressBar {...currentlyLoading} />
          <InvalidSizesModal />
          <InvalidDeliveryOptionModal />
          {this.hasPrints() && (
            <div className="print-order__filter">
              <PhotosFilter
                sizes={sizesByFinish}
                availableSizes={availableSizes}
                deliveryOption={deliveryOption}
                viewingSizeKey={viewingSizeKey}
                onChange={this.handleViewingSizeChanged}
                onResize={this.handleResize}
              />
            </div>
          )}
        </aside>
        <main className="prints-builder__list" onScroll={this.handleScroll}>
          {(!orderedPhotosLength && (
            <AddPhotosDevice onClick={this.handleAddPhotos} />
          )) || (
            <PhotosGrid
              availableSizes={availableSizes}
              deliveryOption={deliveryOption}
              onAdvancedEditPhoto={this.handleAdvancedEdit}
              sizes={sizesByFinish}
              viewingSizeKey={viewingSizeKey}
              orderedPhotos={orderedPhotos}
              invalidDeliveryOptionSelected={invalidDeliveryOptionSelected}
              handleAddPhotos={this.handleAddPhotos}
            />
          )}
        </main>
        {!orderedPhotosLength && (
          <Footer>
            <Button
              className="btn btn-link btn-underline"
              onClick={this.handleAddPhotos}
              disabled={invalidDeliveryOptionSelected}>
              + Add more photos
            </Button>
          </Footer>
        )}
        <AdvancedEditor
          ref={ref => (this.advancedEditorRef = ref)}
          availableSizes={availableSizes}
        />
        <PhotoRemoveConfirmation />
        <FullScreenSpinner show={!ready} />
      </div>
    );
  },
  addToCartEnabled() {
    return this.hasPrints() && !this.state.currentlyLoading;
  },

  handleViewportResize() {
    const vh = window.innerHeight * 0.01;
    genericHelpers.debounce(
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    );
  },

  handleAdvancedEdit(sizeKey, imageId) {
    const size = this.getSizeFromKey(sizeKey);
    const photo = SizeHelpers.augment.individual(
      this.getPhoto(size, imageId, true),
      size
    );

    this.advanced_edit = {
      size,
      photo,
    };

    this.advancedEditor().setData({
      photo,
      availableSizes: this.availableSizesForSelectedDeliveryAndFinish(),
      sizes: [...this.state.sizes],
    });
  },

  refreshEL2(sizeKey, imageId) {
    if (this.advanced_edit) {
      this.handleAdvancedEdit(sizeKey, imageId);
    }
  },

  handleSessionTimeout() {
    const { initSessionTimeout } = this.props;

    if (initSessionTimeout) {
      startSessionTimeout();
    }
  },

  handleScroll() {
    $('#summary-chart').collapse('hide');
  },

  allowZeroQuantity: () => false,
});

MobilePrintsBuilder.propTypes = {
  urls: PrintsBuilderUrlsShape.isRequired,
  features: PropTypes.object,
  uploadFromGalleryListenerUrl: PropTypes.string,
};

export default MobilePrintsBuilder;
